import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const VoucherGroupsQuery = gql`
  query($domain: String!) {
    staticVoucherGroups(domain: $domain) {
      id
      title
      source
      type
      amount

      active
      
      minimumPriceOfSingleItem
      maximumPriceOfSingleItem
      minimumPriceOfOrder
      maximumPriceOfOrder

      minimumPricesOfSingleItem {
        currencyId
        priceWithout
        recommendedPriceWithout
      }
      maximumPricesOfSingleItem {
        currencyId
        priceWithout
        recommendedPriceWithout
      }
      minimumPricesOfOrder {
        currencyId
        priceWithout
        recommendedPriceWithout
      }
      maximumPricesOfOrder {
        currencyId
        priceWithout
        recommendedPriceWithout
      }

      applyToDiscountedGoods

      freeShipping {
        id
      }

      customerGroups {
        id
      }
    }
    languages {
      id
      value
    }
  }
`;

const CreateStaticVoucherGroupMutation = gql`
  mutation($domain: String!, $voucherGroup: StaticVoucherGroupInput!) {
    createStaticVoucherGroup(domain: $domain, voucherGroup: $voucherGroup) {
      id
    }
  }
`;

const UpdateStaticVoucherGroupMutation = gql`
  mutation($id: String!, $voucherGroup: StaticVoucherGroupInput!) {
    updateStaticVoucherGroup(id: $id, voucherGroup: $voucherGroup) {
      id
    }
  }
`;

const DeleteStaticVoucherGroupMutation = gql`
  mutation($id: String!) {
    deleteStaticVoucherGroup(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetStaticVoucherGroupsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const {
      staticVoucherGroups,
      createStaticVoucherGroup,
      updateStaticVoucherGroup,
      deleteStaticVoucherGroup
    }: any = this.props;
    return this.props.children({
      staticVoucherGroups,
      createStaticVoucherGroup,
      updateStaticVoucherGroup,
      deleteStaticVoucherGroup
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(VoucherGroupsQuery, {
    name: 'staticVoucherGroups'
  }),
  graphql<IInputProps, Response>(CreateStaticVoucherGroupMutation, {
    name: 'createStaticVoucherGroup'
  }),
  graphql<IInputProps, Response>(UpdateStaticVoucherGroupMutation, {
    name: 'updateStaticVoucherGroup'
  }),
  graphql<IInputProps, Response>(DeleteStaticVoucherGroupMutation, {
    name: 'deleteStaticVoucherGroup'
  })
)(GetStaticVoucherGroupsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/StaticVoucherGroups/StaticVoucherGroups.tsx